<template>
  <card class="card" title=""><br />
    <div class="row">
      <div class="col-md-3" :style="statusData">
        <label>Busqueda</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Buscar ..." v-model="word" />
          <div class="input-group-append">
            <button class="btn btn-info" type="info" @click="() => { page = 1; getBackups() }">
              <i class="material-icons white-text">search</i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-3" :style="statusData">
        <label>Desde</label>
        <div class="input-group mb-3">
          <input
            class="form-control"
            type="date"
            style="padding-left: 30px"
            :max='currentDate'
            v-on:change="getBackups()"
            v-model="date1"
          />
        </div>
      </div>
      <div class="col-md-3" :style="statusData">
        <label>Hasta</label>
        <div class="input-group mb-3">
          <input
            class="form-control"
            type="date"
            style="padding-left: 30px"
            :max='currentDate'
            v-on:change="getBackups()"
            v-model="date2"
          />
        </div>
      </div>
      <div class="col-md-3" :style="{ paddingRight: '33px' }" title="">
        <label :hidden="hidden">Estaciones</label>
        <div class="d-flex" :style="statusData">
          <vSelect
            :options="stations"
            placeholder="Selecciona..."
            v-model="stationId"
            style="width: 100%"
            :hidden="hidden"
            v-on:input="() => { page = 1; getBackups() }"
          />
        </div>
      </div>
    </div><br />

    <div class="table-responsive">
      <div class="col-md-12">

        <div :hidden="status">
          <div class="alert alert-info" role="alert">
            <center>
              Cargando datos, por favor espere ...
            </center>
          </div>
        </div>

        <div class="table-responsive">
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th v-for="col in headers" :key="col.label">{{ col.label }}</th>
            </tr>
          </thead>
          <tbody v-if="content.length > 0">
            <tr v-for="(b) in content" :key="b.id">
              <td>{{ b.station_id.station }}</td>
              <td>{{ (b.uploaded_date) }}</td>
              <td>{{ b.filesize }}</td>
              <td>{{ b.file_name }}</td>
              <td>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: 'green' }"
                  @click="e => download(b.id)" href="#" title="Descargar">
                  download
                </i>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: 'DodgerBlue' }"
                  @click="e => send(b.id)" href="#" title="Enviar por email">
                  email
                </i>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" style="background-color:#eee;">
                <center> Información no encontrada </center>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        <div v-if="content.length > 0">
          <p class="text-right" :style="{ paddingRight: '11px' }" v-if="count > (page * 5)">
            {{ ((page - 1) * 5) + 1 }} - {{ page * 5 }} de {{ count }} registros
          </p>
          <p class="text-right" :style="{ paddingRight: '11px' }" v-else>
            {{ ((page - 1) * 5) + 1 }} - {{ count }} de {{ count }} registros
          </p><br />
        </div>
        <div v-else> </div>
      </div><br />

      <div class="d-flex justify-content-center" :style="statusData">
        <b-pagination v-model="page" :total-rows="count" prev-text="Anterior" next-text="Siguiente" :per-page="5"
          @change="handlePageChange" />
      </div>
    </div>
  </card>
</template>

<script>
import backupsService from '../../services/backupsService';
import state from "../../store/state";
import vSelect from "vue-select";
import store from "../../store";
import Swal from 'sweetalert2';
import { dateFormat } from "../../helpers";

export default {
  components: {
    vSelect
  },
  name: "backups",
  data() {
    return {
      stations: [],
      headers: [],
      content: [],
      currentStation: null,
      currentIndex: -1,
      word: "",
      statusData: {},
      status: true,
      stationId: null,
      page: 1,
      count: 0,
      date1: '',
      date2: '',
      hidden: 
        localStorage.getItem('role') === 'ADMIN' ||
        localStorage.getItem('role') === 'SUPPORT' ? false : true,
      currentDate: dateFormat().toString()
    };
  },
  methods: {
    getRequestParams(page, word, stationId, date1, date2) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (word) {
        params["word"] = word;
      }

      if (stationId) {
        params["stationId"] = stationId;
      }

      if (date1) {
        params["date1"] = date1;
      }

      if (date2) {
        params["date2"] = date2;
      }

      return params;
    },

    async getBackups() {
      this.statusData = { 'pointer-events': 'none', 'opacity': '0.4' };
      this.status = false;
      const params = this.getRequestParams(
        this.page,
        this.word,
        this.stationId,
        this.date1,
        this.date2
      );
      const backups = await backupsService.getBackups(
        params.page, 
        params.word,
        params.stationId ? params.stationId.station : null,
        params.date1,
        params.date2
      );

      const { content } = await backups.data.data;
      const { totalElements } = await backups.data.data;
      this.count = totalElements;
      this.content = content;
      this.statusData = {};
      this.status = true;
    },

    handlePageChange(value) {
      this.page = value;
      this.getBackups();
    },

    refreshList() {
      this.getBackups();
      this.currentStation = null;
      this.currentIndex = -1;
    },

    setActiveStation(station, index) {
      this.currentStation = station;
      this.currentIndex = index;
    },

    async download(id) {
      const resp = await backupsService.getFile(id)
      if (resp.data.message.toString() === 'no data') {
        swal({
          title: '¡Aviso!', 
          text: 'No se encontro el archivo, consulte a su administrador',
          icon: 'warning', 
          timer: 3000, 
          buttons: false
        })
      } else {
        swal({
          title: '¡Aviso!',
          text: 'La descarga inicio',
          icon: 'warning',
          timer: 5000,
          buttons: false
        })
        window.open(resp.data.data, '_blank', 'noreferrer');
      }
    },
    
    async setData( id, email ) {
      const resp = await backupsService.getFile(id)
      if (resp.data.message.toString() === 'no data') {
        swal({
          title: '¡Aviso!',
          text: 'No se encontro el archivo, consulte a su administrador',
          icon: 'warning',
          timer: 5000,
          buttons: false
        })
      } else {
        const form = {
          email: email,
          link: resp.data.data
        }

        const send = await backupsService.sendBackupByEmail(form)
        swal({
          title: '¡Aviso!',
          text: 'El correo ha sido enviado exitosamente',
          icon: 'success',
          timer: 5000,
          buttons: false
        })
      }
    },

    async send(id) {
      Swal.fire({
        title: 'Escribe el email de destino',
        input: 'text',
        inputPlaceholder: 'Escribe el email de destino',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Enviar',
        customClass: {
          validationMessage: 'my-validation-message',
        },
        preConfirm: async (value) => {
          if (!value) {
            Swal.showValidationMessage('<i class="fa fa-info-circle"></i> Por favor escribe un correo electrónico')
          }
          if(value) {
            const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            if(regex.test(value)) {
              this.setData(id, value)
            } else {
              Swal.showValidationMessage('<i class="fa fa-info-circle"></i> Correo electrónico inválido')
            }
          }
        },
      })
    },

    formatDate ( date ) {
    const d = new Date(date)
    const dformat = [
        d.getFullYear(),
        (d.getMonth() + 1)
            .toString()
            .padStart(2, '0'),
        d.getDate()
            .toString()
            .padStart(2, '0')
        ].join('-')

        return dformat
    }
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted() {
    this.getBackups();
    this.content = state.backups.list;
    this.headers = state.backups.headers;
    this.stations = []

    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }
  },
  watch: {
    name(val) {
      localStorage.stations = val;
    }
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.material-icons {
  line-height: 0.6 !important;
}

.table-responsive {
  overflow: auto !important;
}
</style>
